export default __webpack_public_path__ + "static/media/lady_visa.f68d3367.jpg";